import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { DoorOpenIcon, MoonIcon, FlameIcon, ShieldAlertIcon } from 'lucide-react';
export function MethodSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const modules = [{
    title: 'La Puerta del Éxito',
    description: 'Cómo convertir tu entrada en un imán de oportunidades reales.',
    icon: DoorOpenIcon
  }, {
    title: 'El Santuario del Descanso',
    description: 'Por qué "dormir bajo una ventana" debilita tu firmeza y cómo corregirlo con el Poder del Par.',
    icon: MoonIcon
  }, {
    title: 'El Motor de Abundancia',
    description: 'Sincroniza tu cocina para que la prosperidad deje de ser un deseo y sea tu realidad.',
    icon: FlameIcon
  }, {
    title: 'Eliminación de Fugas Energéticas',
    description: 'Detecta y cierra los puntos donde tu energía y dinero se están escapando hoy mismo.',
    icon: ShieldAlertIcon
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-sage relative overflow-hidden" data-id="element-47">
      {/* Top organic curve */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180" data-id="element-48">
        <svg className="relative block w-full h-[50px] sm:h-[100px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-49">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,116.8,201.39,109.4,242.41,105.1,283.4,91.8,321.39,56.44Z" fill="#ffffff" data-id="element-50"></path>
        </svg>
      </div>

      <div className="max-w-6xl mx-auto relative z-10 pt-12" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-52">
          <p className="text-cream/90 text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed font-light" data-id="element-53">
            Este no es un libro de decoración. Es una guía de Arquitectura
            Invisible. He destilado años de estudio con grandes maestros en
            Oriente para entregarte una metodología de diseño consciente que se
            adapta al ritmo de vida moderno. Micro-ajustes de 5 minutos que
            generan cambios de 180 grados en tu bienestar.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-54">
          {modules.map((mod, index) => <motion.div key={index} variants={cardVariants} className="bg-cream rounded-2xl p-8 shadow-warm border-t-4 border-gold relative overflow-hidden group" data-id="element-55">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -mr-16 -mt-16 transition-transform duration-500 group-hover:scale-110" data-id="element-56"></div>

              <div className="flex items-start space-x-6 relative z-10" data-id="element-57">
                <div className="flex-shrink-0" data-id="element-58">
                  <div className="w-14 h-14 rounded-full bg-terracotta/10 flex items-center justify-center border border-terracotta/20" data-id="element-59">
                    <mod.icon className="w-7 h-7 text-terracotta" aria-hidden="true" data-id="element-60" />
                  </div>
                </div>
                <div data-id="element-61">
                  <h3 className="text-xl font-serif text-charcoal mb-3 font-semibold" data-id="element-62">
                    {mod.title}
                  </h3>
                  <p className="text-charcoal/70 leading-relaxed" data-id="element-63">
                    {mod.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}